/* global ApplePaySession, ApplePayError */

(function () {

console.log('[apple-pay] script loaded');

var cfg = window.applePayConfig || {};
cfg.totalExpressPrice    = Number(cfg.totalExpressPrice);
cfg.defaultTransportPrice = Number(cfg.defaultTransportPrice);

function debugApple(text) {
    if (document.cookie.split(';').some(function (c) { return c.trim() === 'appleDebug=1'; })) {
        console.log('Debuging: ', text);
    }
}

// Check if ApplePay is available
var merchantId = cfg.merchantId;
var applePayWrapperSelector = '.js-detail-express-checkout-btn-wrapper-apple-express';

debugApple('apple log');

// Match the backend merchant environment before the SDK checks domain eligibility.
if (window.ApplePayWebOptions && typeof window.ApplePayWebOptions.set === 'function') {
    window.ApplePayWebOptions.set({ environment: cfg.environment === 'sandbox' ? 'sandbox' : 'prod' });
}

if (window.ApplePaySession && typeof ApplePaySession.applePayCapabilities === 'function') {
    debugApple('applepaysession');
    debugApple('applePayCapabilities begin');

    Promise.resolve()
        .then(function () {
            return ApplePaySession.applePayCapabilities(merchantId);
        })
        .then(function (capabilities) {
            debugApple('applePayCapabilities status: ' + capabilities.paymentCredentialStatus);
            // Check if the person has an active payment credential provisioned in Wallet.
            switch (capabilities.paymentCredentialStatus) {
                case 'paymentCredentialsAvailable':
                    debugApple('Display an Apple Pay button and offer Apple Pay as the primary payment option.');
                    initApplePayButton();
                    break;
                case 'paymentCredentialStatusUnknown':
                    debugApple('Display an Apple Pay button and offer Apple Pay as a payment option.');
                    initApplePayButton();
                    break;
                case 'paymentCredentialsUnavailable':
                    debugApple('Consider displaying an Apple Pay button.');
                    initApplePayButton();
                    break;
                case 'applePayUnsupported':
                    debugApple('Don\'t show an Apple Pay button or offer Apple Pay.');
                    hideApplePayButton();
                    break;
                default:
                    fallbackApplePayAvailability();
                    break;
            }
        })
        .catch(function (err) {
            debugApple(err);
            fallbackApplePayAvailability();
        });
} else {
    fallbackApplePayAvailability();
}

function fallbackApplePayAvailability() {
    try {
        if (window.ApplePaySession && ApplePaySession.canMakePayments()) {
            initApplePayButton();
            return;
        }
    } catch (err) {
        debugApple(err);
    }
    hideApplePayButton();
}

function hideApplePayButton() {
    var btn = document.getElementById('applePayButtonTag');
    if (btn) {
        // Quick Purchase also checks this attribute before offering the method.
        btn.setAttribute('hidden', '');
    }
    var wrapper = document.querySelector(applePayWrapperSelector);
    if (wrapper) {
        wrapper.style.display = 'none';
    }
}

function initApplePayButton() {
    var btn = document.getElementById('applePayButtonTag');
    if (!btn) {
        debugApple('initApplePayButton: btn not found');
        return;
    }
    debugApple('initApplePayButton: btn found');

    var wrapper = document.querySelector(applePayWrapperSelector);
    debugApple('initApplePayButton: wrapper ' + (wrapper ? 'found' : 'not found'));

    if (btn.hasAttribute('hidden') && wrapper) {
        debugApple('initApplePayButton: btn is hidden on init, hiding wrapper');
        wrapper.style.display = 'none';
    }

    var observer = new MutationObserver(function () {
        if (!wrapper) return;
        var isHidden = btn.hasAttribute('hidden');
        debugApple('initApplePayButton: MutationObserver fired, isHidden: ' + isHidden);
        wrapper.style.display = isHidden ? 'none' : '';
        if (!isHidden) tryInjectStyle();
    });
    observer.observe(btn, { attributes: true, attributeFilter: ['hidden'] });

    var tryInjectStyle = function () {
        if (btn.shadowRoot) {
            debugApple('initApplePayButton: shadowRoot found, injecting style');
            var style = document.createElement('style');
            style.textContent = '.apple-pay-btn > span > svg { max-height: 30px !important; }';
            btn.shadowRoot.appendChild(style);
            return true;
        }
        debugApple('initApplePayButton: shadowRoot not yet available');
        return false;
    };

    if (!btn.hasAttribute('hidden') && !tryInjectStyle()) {
        debugApple('initApplePayButton: btn visible but shadowRoot not ready, starting interval');
        var interval = setInterval(function () {
            if (tryInjectStyle()) {
                debugApple('initApplePayButton: style injected via interval, clearing');
                clearInterval(interval);
            }
        }, 50);
    }

    btn.addEventListener('click', function () {
        if (!btn.classList.contains('disabled')) {
            createSession();
        }
    });
}

function getSelectedOption() {
    var form = document.getElementById('addToBasket');
    var data = $(form).serializeArray();
    var size = '';
    data.forEach(function (dataObject) {
        if (dataObject.name === 'detail_size') {
            size = dataObject.value;
        }
    });
    return size;
}

function fetchSizeContent(sizeId) {
    return $('#js-detail-select-size option[value="' + sizeId + '"]').text();
}

var selectedTransportID = cfg.defaultTransportId;
var totalAmount = null;
var lineItems = null;
var shippingContact = null;
var shippingPrices = null;
var transportDataApple = null;

function createSession() {
    var size = getSelectedOption();
    if (!size) {
        return;
    }

    shippingPrices = cfg.transportPrices;

    var sizeInMs = cfg.msSizeIds && cfg.msSizeIds.includes(parseInt(size));
    transportDataApple = cfg.transportDataApple.filter(function (t) {
        if (cfg.msOnlyTransportIds && cfg.msOnlyTransportIds.includes(parseInt(t.identifier))) {
            return sizeInMs;
        }
        return true;
    });

    var sizeText = fetchSizeContent(size);
    totalAmount = (cfg.totalExpressPrice + cfg.defaultTransportPrice).toFixed(2);
    lineItems = [
        {
            label: cfg.title + ' - ' + sizeText,
            amount: cfg.totalExpressPrice,
            type: 'final',
        },
        {
            label: cfg.defaultTransportName,
            amount: cfg.defaultTransportPrice,
            type: 'final',
        }
    ];

    var request = {
        countryCode: (cfg.expressCountryCode === 'EU' ? 'CZ' : cfg.expressCountryCode),
        currencyCode: cfg.currencyCode,
        supportedNetworks: ['visa', 'masterCard', 'amex', 'discover'],
        merchantCapabilities: ['supports3DS'],
        total: {
            label: cfg.shopName,
            amount: cfg.totalExpressPrice + cfg.defaultTransportPrice
        },
        requiredShippingContactFields: [
            'email',
            'name',
            'phone',
            'postalAddress',
        ],
        lineItems: lineItems,
        shippingMethods: transportDataApple
    };

    var session = new ApplePaySession(10, request);
    session.begin();

    // ApplePay validation
    session.onvalidatemerchant = function (event) {
        validateApplePaySession(event.validationURL, function (merchantSession) {
            debugApple('completeMerchantValidation type: ' + typeof merchantSession);
            debugApple('completeMerchantValidation value: ' + JSON.stringify(merchantSession).substring(0, 200));
            try {
                session.completeMerchantValidation(merchantSession);
            } catch (e) {
                debugApple('completeMerchantValidation error: ' + e);
            }
        });
    };

    // After validated submit ApplePay
    session.onpaymentauthorized = function (event) {
        var phone = '';
        try { phone = event.payment.shippingContact.phoneNumber || ''; } catch (e) { phone = ''; }
        var cleanedPhone = phone.replace(/[\s\-().]/g, '');

        if (!cleanedPhone || !/^\+?[1-9]\d{7,14}$/.test(cleanedPhone)) {
            session.completePayment({
                status: ApplePaySession.STATUS_FAILURE,
                errors: [new ApplePayError('shippingContactInvalid', 'phoneNumber', cfg.phoneErrorText)]
            });
            debugApple('WRONG PHONE ' + phone + ' vs ' + cleanedPhone);
            return;
        }

        applePaySubmit(event.payment, function (payload) {
            if (parseInt(payload.status) >= 400) {
                session.completePayment(ApplePaySession.STATUS_FAILURE);
                showToast(cfg.paymentFailedText, {
					type: 'toast',
                    svg: 'danger',
                    delay: false,
                    innerClass: 'global-toast--danger',
                });
            } else {
                session.completePayment(ApplePaySession.STATUS_SUCCESS);
                setTimeout(function () {
                    window.location.href = payload.redirectUrl;
                }, 3000);
            }
        });
    };

    session.oncancel = function () {
        // window.location.href = '/order/change-payment?show_error=1&checkout=1';
    };

    session.onshippingcontactselected = function (event) {
        shippingContact = event.shippingContact;

        var selectedCountryCode = shippingContact.countryCode;
        var shopCountryCode = cfg.expressCountryCode;
        var errors = [];

        var newTotal = {
            label: cfg.shopName,
            amount: totalAmount,
            type: 'final'
        };
        var update = {
            status: ApplePaySession.STATUS_SUCCESS,
            newTotal: newTotal,
            newLineItems: lineItems,
            newShippingMethods: transportDataApple
        };

        if (selectedCountryCode.toUpperCase() !== shopCountryCode.toUpperCase()) {
            debugApple('WRONG COUNTRY');
            update.status = ApplePaySession.STATUS_FAILURE;
            errors.push(new ApplePayError('addressUnserviceable', 'country', cfg.invalidCountryText));
            update.errors = errors;
        }

        session.completeShippingContactSelection(update);
    };

    session.onshippingmethodselected = function (event) {
        var selectedMethod = event.shippingMethod;
        totalAmount = Number(cfg.totalExpressPrice) + Number(selectedMethod.amount);

        lineItems = [
            {
                label: cfg.title,
                amount: Number(cfg.totalExpressPrice).toFixed(2),
                type: 'final'
            },
            {
                label: selectedMethod.label,
                amount: selectedMethod.amount,
                type: 'final'
            }
        ];

        var newTotal = {
            label: cfg.shopName,
            amount: totalAmount.toFixed(2),
            type: 'final'
        };
        var update = {
            status: ApplePaySession.STATUS_SUCCESS,
            newTotal: newTotal,
            newLineItems: lineItems
        };

        selectedTransportID = selectedMethod.identifier;

        session.completeShippingMethodSelection(update);
    };
}

var validateApplePaySession = function (validationUrl, callback) {
    $.ajax({
        url: cfg.applePayValidationUrl,
        data: { validationUrl: validationUrl }
    }).done(function (payload) {
        debugApple(payload);
        callback(payload);
    }).fail(function (xhr, status, err) {
        debugApple('validateApplePaySession FAIL: ' + status + ' ' + err);
    });
};

var applePaySubmit = function (payment, callback) {
    var size = getSelectedOption();
    var paymentData = {};
    paymentData.option = size;
    paymentData.productId = cfg.productId;
    paymentData.paymentId = cfg.paymentId;
    paymentData.transportId = selectedTransportID;
    paymentData.shippingAddress = payment.shippingContact;
    paymentData.email = payment.shippingContact.emailAddress;
    paymentData.paymentToken = JSON.stringify(payment.token);
    paymentData.shippingPrice = shippingPrices[selectedTransportID];
    $.ajax({
        url: cfg.createExpressOrderUrl,
        type: 'POST',
        data: paymentData
    }).done(function (payload) {
        callback(payload);
    });
};

}());
